<template>
  <div class="common_content">
    <div class="common_title_label">
      {{titleLabel}}
    </div>
    <div class='common_content_label'>
      {{contentLabel}}
    </div>
    <div class='common_content_buttons'>
      <input v-if='showDeleteButton' type=button :value='deleteButtonLabel' class="common_delete_button" @click="$emit('delete')">
      <input type=button :value='finishButtonLabel' class="finish_button" @click="$emit('ok')">
    </div>
  </div>
</template>

<script>

export default {
  props: {
    titleLabel: String,
    contentLabel: String,
    showDeleteButton: Boolean,
    finishButtonLabel: String
  },
  data () {
    return {
      deleteButtonLabel: '削除'
    }
  },
  computed: {
    requiredItemLabel () {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputAddUpdate (e) {
      this.$emit('inputAddUpdate', e)
    }
  }
}
</script>
<style scoped>
.finish_button,
.common_delete_button {
  width: 150px;
  height: 45px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/corporationCommonView/corporationCommonComponents/contentSection.vue